import React from "react";
import logourl from "../css/images/logo-big.jpg";
import { Link } from "react-router";

const WelcomeScreen = props => {
  const { user } = props;
  return (
    <div className="box welcome">
      <img width="306" height="108" src={logourl} role="presentation" />
      <p>
        Herzlich willkommen beim Köln-Atlas, Ihrer Suchmaschine für die Bezirke
        Nippes und Mülheim!
      </p>
      {!user._key ? (
        <p>
          Falls Sie bereits ein Konto besitzen,{" "}
          <Link to="/login">loggen Sie sich ein</Link>. Falls nicht,{" "}
          <Link to="/user">registrieren Sie sich kostenlos</Link>, um eine
          Einrichtung anzulegen.
        </p>
      ) : (
        <p>
          Sie sind als {user.first_name} {user.last_name} eingeloggt.
        </p>
      )}
    </div>
  );
};

export default WelcomeScreen;



/** WEBPACK FOOTER **
 ** ./src/components/WelcomeScreen.jsx
 **/